import { Menu, Tooltip } from 'antd';
import _ from 'lodash';

import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { initialStateModel, recentChatSocketReducerStateModel } from '../../../models/model';
import styles from "./scss/leftsidebar.module.scss";


const { SubMenu } = Menu;

export default function Filterlayer(props: any) {
  const [isOpen, setIsOpen] = useState(false);
  const allReducer: initialStateModel = useSelector((state: initialStateModel) => state);
  let { contactReducer } = allReducer;
  let workContact = contactReducer?.workContactsnew;
  let teamContact = contactReducer?.teamContacsnew;
  const contactList: recentChatSocketReducerStateModel = useSelector((state: initialStateModel) => state.chatSocketRecentReducerState);
  let { savedChatList } = contactList;

  const toggleArrow = () => {
    setIsOpen(!isOpen);
  }

  const handleFilterLayer = (filterData: string) => {
    props.setFilteredLayer(filterData);
  };
  let totalUnreadCount = 0;
  const filteredContacts = _.filter(props.unreadContacts, (value) => {
    let contactsDetail = value?.type === 1 ? workContact[value?.to] : teamContact["con" + value?.chatId];
    if (contactsDetail !== undefined) {
      totalUnreadCount = totalUnreadCount + value?.unreadCount;
    }
    return contactsDetail !== undefined;
  });

  return (
    <>
      <div className={styles.filtelayer}>
        {/* <Menu
          onOpenChange={toggleArrow}
          defaultSelectedKeys={['1']}
          mode="inline"
          className="filtersmain"
        >
          <SubMenu key="sub1" title="Filters" className="filterChats"

            icon={<><span className="iconToggle"></span><Tooltip mouseEnterDelay={0.5} placement="top" title={isOpen ? "Click to collapse filters" : "Click to show filters"} className='cusTooltip'
            overlayClassName='customTooltip'>

            </Tooltip></>}>
            <ul>
              {filteredContacts && Array.isArray(filteredContacts) && filteredContacts.length > 0 &&
                <li onClick={() => handleFilterLayer("Unread")}><span className="icon_mail"
                ></span><span className={styles.filterTitles}>Unread</span><span className={styles.counts}>{filteredContacts?.length}</span></li>}
              <li onClick={() => handleFilterLayer("Saved")}><span className="icon_ribbonfill"
              ></span><span className={styles.filterTitles}>Saved</span><span className={styles.counts}>{savedChatList.length}</span></li>
              <li onClick={() => handleFilterLayer("Archive")}><span className="icon_taskfill"
              ></span><span className={styles.filterTitles}>Archived</span><span className={styles.counts}>{props?.searchArchive?.length}</span></li>
            </ul>
          </SubMenu>
        </Menu> */}
        <ul className={styles.chatFilterList}>
          {/* {filteredContacts && Array.isArray(filteredContacts) && filteredContacts.length > 0 &&
            <li onClick={() => handleFilterLayer("Unread")}><span className="icon_mail"
            ></span><span className={styles.filterTitles}>Unread</span><span className={styles.counts}>{filteredContacts?.length}</span></li>} */}
          <li onClick={() => handleFilterLayer("Saved")}><span className="icon_ribbonfill"
          ></span><span className={styles.filterTitles}>Saved</span><span className={styles.counts}>{savedChatList.length}</span></li>
          {/* <li onClick={() => handleFilterLayer("Draft")}><span className="icon_edit"
              ></span><span className={styles.filterTitles}>Drafts</span><span className={styles.counts}>{props?.draftContact.length}</span></li>
              <li onClick={() => handleFilterLayer("Failed")}><span className="icon_failedfill"
              ></span><span className={styles.filterTitles}>Failed</span><span className={styles.counts}>{props?.failedContact?.length}</span></li> */}
          <li onClick={() => handleFilterLayer("Archive")}><span className="icon_taskfill"
          ></span><span className={styles.filterTitles}>Archived</span><span className={styles.counts}>{props?.searchArchive?.length}</span></li>
        </ul>
      </div>

    </>
  );
}
